import React, {useState} from 'react';

import * as APPDATA from '@/constants/pcConstAppData';

import AdvanceCycleSetup from '../cycleSetup/AdvanceCycleSetup';
import AdvSetupPageMenu from '../reusable/AdvSetupPageMenu';
import AdvSetupTopMenu from '../reusable/AdvSetupTopMenu';

import style from '../reusable/AdvSetup.less';

const AdvSetupMenu = {
  GENERAL: 'GENERAL SETUP',
  CONCENTRATE: 'CONCENTRATE',
  DIAFILTRATION: 'BUFFER EXCHANGE',
  PRIME: 'PRIME',
  RECOVERY: 'RECOVERY',
  CYCLE_SETUP: 'CYCLE SETUP',
};

function AdvanceSetupMenu() {
  const [activeMenu, setActiveMenu] = useState(AdvSetupMenu.GENERAL);

  const onChangeMenu = (e) => {
    setActiveMenu(e);
  };

  return (
    <div style={style.constraint}>
      <AdvanceCycleSetup activePage={activeMenu} />
      <AdvSetupTopMenu activeTopMenu={APPDATA.ADVANCED_SETUP_NEW} />
      <AdvSetupPageMenu
        activePage={activeMenu}
        onChangeMenu={(e) => onChangeMenu(e)}
      />
    </div>
  );
}

export default AdvanceSetupMenu;
